import { translate } from '@ngneat/transloco';

export function getClientSpacePartnerPaymentExtraTranslated(): string {
  return translate('Les factures liees a des commandes et renouvellements effectues par vos soins seront disponibles sur votre compte.');
}
